import App from "./App";
import ReactDOM from 'react-dom/client';
import { render, unmountComponentAtNode } from "react-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient()

class WebComponent extends HTMLElement {
  // connectedCallback() {
  //   render(
  //     <React.StrictMode>
  //       <App />
  //     </React.StrictMode>,
  //     this
  //   );
  // }

  connectedCallback() {
    const root = ReactDOM.createRoot(this);
    const props = {
      objectDefinitionId: this.getAttribute('id'),
      objectDefinitionERC: this.getAttribute('erc'),
    };
    root.render(
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
  );
  }

  disconnectedCallback() {
    unmountComponentAtNode(this);
  }
}

const ELEMENT_NAME = "reactjs-dwp-applications";

if (customElements.get(ELEMENT_NAME)) {
  // eslint-disable-next-line no-console
  console.log(
    `Skipping registration for <${ELEMENT_NAME}> (already registered)`
  );
} else {
  customElements.define(ELEMENT_NAME, WebComponent);
}